  // auth.js
export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'

// Imprimir

export const  SET_IMPRIMIR = 'SET_IMPRIMIR'
export const  SET_PACIENTE_IMP = 'SET_PACIENTE_IMP'
export const  LIMPAR_PACIENTE_IMP = 'LIMPAR_PACIENTE_IMP'
export const  SET_CONFIG_IMP = 'SET_CONFIG_IMP'

// Pagamentos
export const SET_TIPO_PAG = 'SET_TIPO_PAG'
export const SET_PAGAMENTO = 'SET_PAGAMENTO'
export const SET_PAGAMENTOS = 'SET_PAGAMENTOS'
export const SET_TOKEN_CARTAO = 'SET_TOKEN_CARTAO'
export const SET_VALIDAR_FORM_PAG = 'SET_VALIDAR_FORM_PAG'
export const SET_BANDS_CARD_PAGSERURO = 'SET_BANDS_CARD_PAGSERURO'

// Modelos de Documentos do usuário
export const  SET_MODELO_DOC = 'SET_MODELO_DOC'

// configurações do sistema

export const SET_LOAD_GLOBAL = 'SET_LOAD_GLOBAL'
export const SET_LOADING = 'SET_LOADING'
export const SET_CONFIG = 'SET_CONFIG'

// lang.js
export const SET_LOCALE = 'SET_LOCALE'

// paciente
export const SET_PACIENTE = 'SET_PACIENTE'
export const SET_PACIENTES = 'SET_PACIENTES'

// teste.js
export const SET_TESTE = 'SET_TESTE'
export const SET_TESTE_CATEGS = 'SET_TESTE_CATEGS'
export const SET_TESTE_ASSUNTOS = 'SET_TESTE_ASSUNTOS'

// mudulo de mensagens
export const SET_ALERT = 'SET_ALERT'

// atendimentos
export const SET_ATENDIMENTOS = 'SET_ATENDIMENTOS'
export const SET_FILTRO = 'SET_FILTRO'

export const SET_VERSAO = 'SET_VERSAO'





// WEBPACK FOOTER //
// ./resources/assets/js/store/mutation-types.js